import { useState } from "react";
import { Box, Button } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import { ContractPeriodDealsResponseType } from "../../../../requests_cm/gecoContractsService/types";
import ActivityLogModal from "../../../../common/components/ActivityLogModal/ActivityLogModal";
import { CommentObjectClass } from "../../../../requests_cm/gepoCommentService/types";
import { style } from "../ServicePointsTab/ServicePointCard/ServicePointCard.style";

const DealsLogCell = ({
    deal,
}: {
    deal: ContractPeriodDealsResponseType;

}) => {
    const [selectedActivity, setSelectedActivity] =
        useState<ContractPeriodDealsResponseType | null>(null);



    return (
        <>
            <Box sx={style.commentWrapper}>
                <Button
                    aria-label={`View activity for ${deal.trade_id}`}
                    onClick={() => setSelectedActivity(deal)}
                    sx={
                        style.commentButton
                    }
                >
                    <CommentIcon />{" "}
                </Button>														
            </Box>													
            <ActivityLogModal
                isOpen={selectedActivity !== null}
                onClose={() => setSelectedActivity(null)}
                resourceId={selectedActivity?.id}
                resourceName={`id: ${selectedActivity?.id}, start date: ${selectedActivity?.start_date}, end date: ${selectedActivity?.end_date}, deal type: ${selectedActivity?.deal_type}`}
                resource="deal"
                resourceLabel="Deal"
                commentObjectClass={CommentObjectClass.NOT_SUPPORTED}
                title="Log History for deal"
            />
        </>
    );
};

export default DealsLogCell;
